/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_photos = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************

	this.onready = function() {

		/*
		Trigger photo count
		*/
		$(document).on('keyup','.form-input-photo-before-filename-0,.form-input-photo-before-filename-1,.form-input-photo-before-filename-2,.form-input-photo-before-filename-3,.form-input-photo-before-filename-4,.form-input-photo-before-filename-5,.form-input-photo-before-filename-6,.form-input-photo-before-filename-7,.form-input-photo-before-filename-8,.form-input-photo-before-filename-9,.form-input-photo-before-filename-10,.form-input-photo-before-filename-11,.form-input-photo-before-filename-12,.form-input-photo-before-filename-13,.form-input-photo-before-filename-14,.form-input-photo-before-filename-15,.form-input-photo-before-filename-16,.form-input-photo-before-filename-17,.form-input-photo-before-filename-18,.form-input-photo-before-filename-19',function() {

			var _this_id 	= $(this).attr('name');
			_this_id		= _this_id.split('-');
			_this_id		= _this_id[3];

			if($(this).val() !== '') {
				$('#upload_image_photo-before-' + _this_id).parent('.element-row').removeClass('hidden');
			} else {
				$('#upload_image_photo-before-' + _this_id).parent('.element-row').addClass('hidden');
			}

		});

		/*
		Trigger photo count
		*/
		$(document).on('keyup','.form-input-photo-after-filename-0,.form-input-photo-after-filename-1,.form-input-photo-after-filename-2,.form-input-photo-after-filename-3,.form-input-photo-after-filename-4,.form-input-photo-after-filename-5,.form-input-photo-after-filename-6,.form-input-photo-after-filename-7,.form-input-photo-after-filename-8,.form-input-photo-after-filename-9,.form-input-photo-after-filename-10,.form-input-photo-after-filename-11,.form-input-photo-after-filename-12,.form-input-photo-after-filename-13,.form-input-photo-after-filename-14,.form-input-photo-after-filename-15,.form-input-photo-after-filename-16,.form-input-photo-after-filename-17,.form-input-photo-after-filename-18,.form-input-photo-after-filename-19',function() {

			var _this_id 	= $(this).attr('name');
			_this_id		= _this_id.split('-');
			_this_id		= _this_id[3];

			if($(this).val() !== '') {
				$('#upload_image_photo-after-' + _this_id).parent('.element-row').removeClass('hidden');
			} else {
				$('#upload_image_photo-after-' + _this_id).parent('.element-row').addClass('hidden');
			}

		});

		/*
		Trigger photo count: Werktekening
		*/
		$(document).on('keyup','.form-input-photo-measuredocument-filename-0,.form-input-photo-measuredocument-filename-1,.form-input-photo-measuredocument-filename-2,.form-input-photo-measuredocument-filename-3,.form-input-photo-measuredocument-filename-4,.form-input-photo-measuredocument-filename-5,.form-input-photo-measuredocument-filename-6,.form-input-photo-measuredocument-filename-7,.form-input-photo-measuredocument-filename-8,.form-input-photo-after-filename-9,.form-input-photo-measuredocument-filename-10,.form-input-photo-measuredocument-filename-11,.form-input-photo-measuredocument-filename-12,.form-input-photo-measuredocument-filename-13,.form-input-photo-measuredocument-filename-14,.form-input-photo-measuredocument-filename-15,.form-input-photo-measuredocument-filename-16,.form-input-photo-measuredocument-filename-17,.form-input-photo-measuredocument-filename-18,.form-input-photo-measuredocument-filename-19',function() {

			var _this_id 	= $(this).attr('name');
			_this_id		= _this_id.split('-');
			_this_id		= _this_id[3];

			if($(this).val() !== '') {
				$('#upload_image_photo-measuredocument-' + _this_id).parent('.element-row').removeClass('hidden');
			} else {
				$('#upload_image_photo-measuredocument-' + _this_id).parent('.element-row').addClass('hidden');
			}

		});

		/*
		Deliveryform
		*/
		$(document).on('keyup','.form-input-photo-deliveryform-filename-0,.form-input-photo-deliveryform-filename-1,.form-input-photo-deliveryform-filename-2,.form-input-photo-deliveryform-filename-3,.form-input-photo-deliveryform-filename-4,.form-input-photo-deliveryform-filename-5,.form-input-photo-deliveryform-filename-6,.form-input-photo-deliveryform-filename-7',function() {

			var _this_id 	= $(this).attr('name');
			_this_id		= _this_id.split('-');
			_this_id		= _this_id[3];

			if($(this).val() !== '') {
				$('#upload_image_photo-deliveryform-' + _this_id).parent('.element-row').removeClass('hidden');
			} else {
				$('#upload_image_photo-deliveryform-' + _this_id).parent('.element-row').addClass('hidden');
			}

		});


	};
	 
	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	this.save = function(
		_image_type,
		_image_sort_id,
		_image_file,
		_image_filename
	) {

		var _project_id = $('.js-project-id').val();

		var _url 		= globalUrl + '/a/a/project-photos-after-save';
		
		if(_image_type == 'before') {
			_url 		= globalUrl + '/a/a/project-photos-before-save';
		}
		if(_image_type == 'deliveryform') {
			_project_id = $('.js-deliveryform-id').val();
			_url 		= globalUrl + '/a/a/project-photos-deliveryform-save';
		}
		if(_image_type == 'measuredocument') {
			_project_id = $('.js-measuredocument-id').val();
			_url 		= globalUrl + '/a/a/project-photos-measuredocument-save';
		}

		/*
		Ajax: Save
		*/
		var _image_sort_id_explode = _image_sort_id.split('-');

		/*
		Show: Modal
		*/
		modal.open('loading');

		/*
		XHR: Exact.php first
		XHR: Exact.php first
		XHR: Exact.php first
		XHR: Exact.php first
		*/
		// $.ajax({
		// 	url: globalUrl + '/exact.php',
		// 	data: {
		// 			'what':'foto'
		// 	},
		// 	type: "POST",
		// 	headers: { 
		// 		'go-load':1
		// 	}
		// })
		// .done(function(data) {

		// 	setTimeout(function() {
				
		$.ajax({
			url: _url,
			type: "POST",
			data: {
				_project_id		: _project_id,
				_image_sort_id	: (parseInt(_image_sort_id_explode[2]) + 1),
				_image_file		: _image_file,
				_image_filename	: _image_filename
			},
			headers: { 
				'go-load':1
			}
		})
		.done(function(data) {

			modal.close();

		})
		.always(function() {
		});

		// 	},1000);


		// })
		// .always(function() {
		// });

	};

	this.delete = function(
		_image_type,
		_image_sort_id		
	) {

		var _project_id 	= $('.js-project-id').val();

		var _url 			= globalUrl + '/a/a/project-photos-after-delete';

		if(_image_type == 'before') {
			_url 			= globalUrl + '/a/a/project-photos-before-delete';
		}
		if(_image_type == 'deliveryform') {
			_project_id 	= $('.js-deliveryform-id').val();
			_url 			= globalUrl + '/a/a/project-photos-deliveryform-delete';
		}
		if(_image_type == 'measuredocument') {
			_project_id 	= $('.js-measuredocument-id').val();
			_url 			= globalUrl + '/a/a/project-photos-measuredocument-delete';
		}

		/*
		Ajax: Save
		*/
		$.ajax({
			url: _url,
			type: "POST",
			data: {
				_project_id		: _project_id,
				_image_sort_id	: (parseInt(_image_sort_id) + 1)
			},
			headers: { 
				'go-load':1
			}
		})
		.done(function(data) {
		})
		.always(function() {
		});

	};

	/*
	Disable / Enable the comment field
	*/
	this.inputfield_disabled = function(beforeorafter,id) {

		$('.form-input-photo-' + beforeorafter + '-filename-' + id).prop('disabled','disabled');
		$('.form-input-photo-' + beforeorafter + '-filename-' + id).css({
			'background-color':'#ccc'
		});

	};

	this.inputfield_enabled = function(beforeorafter,id) {

		$('#upload_image_photo-' + beforeorafter + '-' + id).closest('.element-row').addClass('hidden');
		$('#upload_image_photo-' + beforeorafter + '-' + id + '_upload_button').show();

		$('.form-input-photo-' + beforeorafter + '-filename-' + id).val('');
		$('.form-input-photo-' + beforeorafter + '-filename-' + id).prop('disabled','');
		$('.form-input-photo-' + beforeorafter + '-filename-' + id).css({
			'background-color':'#eee'
		});

	};
		
}).apply(specific_photos); 